import React from 'react';

const FormP19T1 = React.memo((props) => {
    let quantityOptions = [];
    for (let i = 0; i < 10; i++) {
        quantityOptions.push(<option value={i}>{i} bundle(s)</option>);
    }

    const handleQuantityChange = (setFunc, event) => {
        setFunc(event.target.value);
    };

    return (
        <form action="">
            <h5 className="description-header">Description</h5>
            <div className="description-section">
                <div><span className="label">Title:</span> UT Physicians/UTHealth Holiday Greeting Cards with Envelope</div>
                <div className="description mt-3">
                    <span className="label">Description:</span> These festive holiday cards are the perfect way to send your
                    best wishes to patients, vendors, staff, and loved ones. The inside of the card is blank so you can write
                    your best seasonal messages. Comes in three unique designs that reflects the spirit of the season.
                    <br />
                    <br />
                    $12 per bundle.
                </div>
                <div className="description-list">
                    <span className="label">Detail:</span>
                    <ul>
                        <li>Standard 5-inch x 7-inch greeting card</li>
                        <li>Paper: 120# matte/dull cover</li>
                        <li>Matching white envelopes</li>
                        <li>Each bundle comes with 25 cards and envelopes</li>
                    </ul>
                </div>
            </div>
            <div className="quantity-fields">
                <div className="card-image">
                    <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-images/printready-holiday-card-1-211124.jpg" alt="Holiday" />
                </div>
                <div className="quantity-field">
                    Quantity:
                    <br />
                    <select value={props.quantity1} onChange={handleQuantityChange.bind(this, props.setQuantity1)}>
                        {quantityOptions}
                    </select>
                </div>
            </div>
            <div className="quantity-fields">
                <div className="card-image">
                    <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-images/printready-holiday-card-2-211124.jpg" alt="Holiday" />
                </div>
                <div className="quantity-field">
                    Quantity:
                    <br />
                    <select value={props.quantity2} onChange={handleQuantityChange.bind(this, props.setQuantity2)}>
                        {quantityOptions}
                    </select>
                </div>
            </div>
            <div className="quantity-fields">
                <div className="card-image">
                    <img className="preview-image" src="https://ac-ut-health.s3.amazonaws.com/static-images/printready-holiday-card-3-211124.jpg" alt="Holiday" />
                </div>
                <div className="quantity-field">
                    Quantity:
                    <br />
                    <select value={props.quantity3} onChange={handleQuantityChange.bind(this, props.setQuantity3)}>
                        {quantityOptions}
                    </select>
                </div>
            </div>
            <br />
        </form>
    );
});

export default FormP19T1;
